import { RECIPIENT, SOURCE, REVENUE_TYPE } from "../../../../src/constants";
import * as React from 'react';
export default {
  RECIPIENT,
  SOURCE,
  REVENUE_TYPE,
  React
};